var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-template',{class:_vm.buttonClasses,attrs:{"primary":_vm.primary,"routeTo":_vm.routeTo,"showArrow":_vm.showArrow,"buttonType":_vm.buttonType}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }